export default "__VITE_ASSET__D$5459AP__"